// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScWnOR {
    /* Reset start */
    border: none;
    margin: 0;
    padding: 0;
    width: auto;
    overflow: visible;

    background: transparent;

    color: inherit;
    font: inherit;

    line-height: normal;

    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;

    -webkit-appearance: none;
    /* Reset end */

    display: inline-flex;
    align-items: center;

    font-family: Madefor-Text, Madefor;

    color: #000;
    white-space: nowrap;

    height: 36px;

    cursor: pointer;
}

/* Reset start */
.ScWnOR::-moz-focus-inner {
    border: 0;
    padding: 0;
}
/* Reset end */

.sI1Vcz {
    line-height: 24px;
    border-bottom: 1px solid #000;
}

.wB9nys {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
}

@media (max-width: 375px) {
    .wB9nys {
        display: none;
    }

    .sI1Vcz {
        border-bottom: 0;
        text-decoration: underline;
    }
}

`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `ScWnOR`,
	"text": `sI1Vcz`,
	"chevron": `wB9nys`
};
export default ___CSS_LOADER_EXPORT___;
